<!-- <div class="col-12">
  <div>
    <span> <b> Note: Comments should be submitted on or before {{commentdate}} </b> </span>
  </div>
</div> -->

<div class="col-12">
  <div [hidden]="!showReqno" class="col-6">
    <h1 class="reqno">{{requestNum}}</h1>
  </div>
  <form [formGroup]="formGroup">
    <kendo-grid [kendoGridBinding]="commentList" [pageSize]="15" [pageable]="true" [sortable]="true" [resizable]="true"
      (edit)="editHandler($event)" (cancel)="cancelHandler($event)" (save)="saveHandler($event)"
      (excelExport)="onExcelExport($event)" [filterable]="enableFilter">

      <ng-template kendoPagerTemplate>
        <div class="k-pager-left">
          <kendo-pager-info></kendo-pager-info>
        </div>
        <div class="k-pager-right">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-input></kendo-pager-input>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
        </div>
      </ng-template>

      <ng-template kendoGridToolbarTemplate>
        <div class="k-grid-toolbar-content d-flex justify-content-end">
          <div class="icons-container">
            <div class="icon-wrap">
              <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10"
                style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">Export to
                Excel</button>
            </div>
          </div>
        </div>
      </ng-template>

      <kendo-grid-column title="S.No" field="SNO" width="30">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div>
            {{rowIndex}}
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Discipline" field="discipline" width="50">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div *ngIf="rowIndex!=0">
            <mat-form-field>
              <mat-label>Select Discipline</mat-label>
              <mat-select [disabled]="setDisable" required formControlName="discipline" required>
                <mat-option *ngFor="let data of disciplineDropdown" [value]="data.deD_Id">
                  {{data.deD_Description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="rowIndex==0">
            <mat-form-field>
              <mat-label>Select Discipline</mat-label>
              <mat-select [disabled]="setDisable" required formControlName="discipline2" required>
                <mat-option *ngFor="let data of disciplineDropdown" [value]="data.deD_Id">
                  {{data.deD_Description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Discipline No" field="Discipline_No" width="45">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div *ngIf="dataItem.comment_Id">
            {{dataItem.disc_No}}
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Panel Comments" field="panel_Comments" width="100">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <span class="no-wrap" eipTooltip="{{dataItem.panel_Comments}}" eipTooltipPosition="auto">
            {{dataItem.panel_Comments}}
          </span>
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div *ngIf="rowIndex!=0">
            <mat-form-field>
              <mat-label></mat-label>
              <textarea matInput [disabled]="setDisable" formControlName="comments" required cols="35"></textarea>
            </mat-form-field>
          </div>
          <div *ngIf="rowIndex==0">
            <mat-form-field>
              <mat-label></mat-label>
              <textarea matInput [disabled]="setDisable" formControlName="comments2" required cols="35"></textarea>
            </mat-form-field>
          </div>
        </ng-template>
      </kendo-grid-column>

      <!-- <kendo-grid-column title="On Behalf" field="onBehalf" width="70" *ngIf='isAdmin'>
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <EIPAutoComplete TextField="member_Name" ValueField="member_Id" WaterMarkText="Panel Member*" required setId="ddlMember" 
                          ShowTextValueField='N' [dataSource]='memberList' [IsCascading]='true' 
                          (valueChange)='memberSelection($event)' [defaultValue]='dataItem.onBehalfId'>
        </EIPAutoComplete>
      </ng-template>
    </kendo-grid-column> -->

      <kendo-grid-column title="Attachments" width="25">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div *ngIf="dataItem.comment_Id">
            <i aria-hidden="true" *ngIf="dataItem.isAttachment!='N'" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment"
              (click)="viewAttachmentClick(dataItem)" style="margin-right: 20px;margin-left: 20px;"></i>
            <i aria-hidden="true" *ngIf="dataItem.isAttachment=='N'" class="fa fa-upload fs-16 eip-mr-5 eip-link" title="Upload Attachment"
              (click)="uploadAttachmentClick(dataItem)"></i>
          </div>
        </ng-template>
        <!-- <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <div *ngIf="dataItem.comment_Id">
          <i aria-hidden="true" class="fa fa-upload fs-16 eip-mr-5 eip-link" title="Attachment" (click)="uploadAttachmentClick(dataItem)"></i>
        </div>
      </ng-template> -->
      </kendo-grid-column>

      <kendo-grid-column title="Comment Type / Category" field="potential_Comment" width="70">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div class="row d-flex">
            <div class="col-xl-10 col-xs-10 col-md-10 col-sm-12">
              {{dataItem.potential_Comment}}
            </div>
            <div class="col-xl-2 col-xs-2 col-md-2 col-sm-12">
              <span *ngIf="dataItem.category=='Medium Risk'">
                <p style="width: 25px;height: 25px; background-color: #ffbf00;margin-top: 5px;"></p> 
              </span>
              <span *ngIf="dataItem.category=='High Risk'">
                <p style="width: 25px;height: 25px; background-color: red;margin-top: 5px;"></p>
              </span>
              <span *ngIf="dataItem.category=='Low Risk'">
                <p style="width: 25px;height: 25px; background-color: darkgreen;margin-top: 5px;"></p>
              </span>
            </div>
          </div>
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div class="row">
            <div *ngIf="rowIndex!=0" class="col-xl-12 col-xs-12 col-md-12 col-sm-12">
              <mat-form-field>
                <mat-label>Select Comment Type</mat-label>
                <mat-select [disabled]="setDisable" required formControlName="potential_comment" required>
                  <mat-option *ngFor="let data of potentialcmd" [value]="data">
                    {{data}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="rowIndex==0" class="col-xl-12 col-xs-12 col-md-12 col-sm-12">
              <mat-form-field>
                <mat-label>Select Comment Type</mat-label>
                <mat-select [disabled]="setDisable" required formControlName="potential_comment2" required>
                  <mat-option *ngFor="let data of potentialcmd" [value]="data">
                    {{data}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="rowIndex!=0" class="col-xl-12 col-xs-12 col-md-12 col-sm-12">
              <mat-form-field>
                <mat-label>Select Comment Category</mat-label>
                <mat-select [disabled]="setDisable" required formControlName="category" required>
                  <mat-option *ngFor="let data of categoryDropdown" [value]="data.deD_Id">
                    {{data.deD_Description}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="rowIndex==0" class="col-xl-12 col-xs-12 col-md-12 col-sm-12">
              <mat-form-field>
                <mat-label>Select comment Category</mat-label>
                <mat-select [disabled]="setDisable" required formControlName="category2" required>
                  <mat-option *ngFor="let data of categoryDropdown" [value]="data.deD_Id">
                    {{data.deD_Description}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>

      <!-- <kendo-grid-column title="Comment Category" field="category" width="70">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div *ngIf="dataItem.category=='Medium Risk'">
            <div style="width: 15px;height: 15px; background-color: #ffbf00;"></div>
          </div>
          <div *ngIf="dataItem.category=='High Risk'">
            <span style="width: 15px;height: 15px; background-color: red;"></span>
          </div>
          <div *ngIf="dataItem.category=='Low Risk'">
            <span style="width: 15px;height: 15px; background-color: darkgreen;"></span>
          </div>
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div *ngIf="rowIndex!=0">
            <mat-form-field>
              <mat-label>Select Category</mat-label>
              <mat-select [disabled]="setDisable" required formControlName="category" required>
                <mat-option *ngFor="let data of categoryDropdown" [value]="data.deD_Id">
                  {{data.deD_Description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="rowIndex==0">
            <mat-form-field>
              <mat-label>Select Category</mat-label>
              <mat-select [disabled]="setDisable" required formControlName="category2" required>
                <mat-option *ngFor="let data of categoryDropdown" [value]="data.deD_Id">
                  {{data.deD_Description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-template>
      </kendo-grid-column> -->

      <!-- <kendo-grid-column title="Comment Status" filed="Comment_Status" width="60">
      <ng-template kendoGridCellTemplate  let-dataItem="dataItem" let-rowIndex="rowIndex" >
        <div *ngIf="dataItem.comment_Id" style="margin-left: 10px;">
            Saved
          </div>
      </ng-template>
    </kendo-grid-column> -->

      <kendo-grid-column title="Comments By" field="comment_By" width="60">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          {{dataItem.comment_By}}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title="" width="10">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div class="icon-container d-flex">
            <span kendoGridEditCommand class="setEditIcon">
              <i class="fa fa-pencil" title="Enter / Edit Response"></i>
            </span>
            <span kendoGridSaveCommand class="setEditIcon" *ngIf="rowIndex!=0">
              <i class="fa fa-save" title="{{ 'Update' }}"></i>
            </span>
            <span *ngIf="rowIndex==0">
              <i class="fa fa-save" title="Add" (click)="newSave(dataItem)" style="margin-left: 10px;"></i>
            </span>
            <span kendoGridCancelCommand class="setSaveIcon" *ngIf="dataItem.comment_Id">
              <i class="fa fa-cancel" title="{{ 'Cancel' }}"></i>
            </span>
          </div>
        </ng-template>
      </kendo-grid-command-column>

      <kendo-grid-excel fileName="PeerReviewComments.xlsx" [fetchData]="allData">
      </kendo-grid-excel>

    </kendo-grid>
  </form>
</div>

<div class="row justify-content-center flex-grow-1" style="margin-top: 10px;">
  <mat-checkbox (change)="onChange()">
    <h6 style="margin-top: 10px;">I have completed filling all my comments.</h6>
  </mat-checkbox>
</div>

<div class="row justify-content-center flex-grow-1">
  <button class="btn btn-primary" id="btnUpdate" (click)="Submit()">
    Submit
  </button>
</div>

<div class="col-12" style="margin-top: 50px;">
  <div>
    <div style="width: 40px; height: 20px; margin-right:25px; background-color: red; position:relative; float:left;">
    </div>
    <div>
      <p>Red: High Risk comment related to major deviation from Codes/Standards, Employer’s & Contract requirements, DBR,
        Statutory, EHS and Security.</p>
    </div>
  </div>
  <div>
    <div
      style="width: 40px; height: 20px; margin-right: 25px; background-color: #ffbf00; position:relative; float:left;">
    </div>
    <div>
      <p>Amber: Medium Risk comments related to Interface and coordination issues, Alternate solutions for cost-time
        effectiveness. Comments not in Red and Green will be categorised to Amber.</p>
    </div>
  </div>
  <div>
    <div style="width: 40px; height: 20px; margin-right: 25px; background-color: green; position:relative; float:left;">
    </div>
    <div>
      <p>Green: Low Risk comments related to more clarity of information, typo-error, legibility issues.</p>
    </div>
  </div>
</div>